import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  CloseButton,
  LeftSide,
  ModalBody,
  ModalContent,
  ModalHeader,
  PrimaInfoModalStyles,
  TextContainer,
  TitleBox,
} from '../Cards/PrimaInfoModal.styles';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';

function FacileCompaniesInfoModal({ setShowModal, quote }) {
  const closeModal = () => {
    setShowModal(false);
  };

  const facileData = quote.quotation_data_facile;

  if (!facileData || !facileData.coverages) {
    return null;
  }

  const {
    name, coverages, typeOfDrive, rightOfOffsets,
  } = facileData;

  // RCA shows the saved quote amount (rca premium + Facile policy fees +
  // Greenia's flat surcharge); other coverages show the raw Facile price.
  const displayCoveragePrice = (coverage) => {
    if (coverage.code === 'rca' && quote.amount != null) {
      return Number(quote.amount).toFixed(2);
    }
    if (typeof coverage.price === 'number') {
      return coverage.price.toFixed(2);
    }
    return null;
  };

  return (
    <PrimaInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="" />
                <h3>Informazione</h3>
              </TitleBox>
              <p>Qui puoi controllare le informazioni su questa offerta.</p>
            </TextContainer>
          </LeftSide>
          <CloseButton onClick={() => closeModal()} aria-label="Chiudi">
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
        </ModalHeader>
        <ModalContent>
          <div className="info-row">
            <span className="info-label">Compagnia:</span>
            <span className="info-value">{name}</span>
          </div>

          {typeOfDrive && (
            <div className="info-row mb-3">
              <span className="info-label">Tipo di Guida:</span>
              <span className="info-value text-capitalize">{typeOfDrive}</span>
            </div>
          )}

          <h3>Garanzie</h3>
          <table className="custom-table-compact">
            <thead>
              <tr>
                <th>Nome Garanzia</th>
                <th>Massimale</th>
                <th>Scoperto</th>
                <th>Prezzo</th>
              </tr>
            </thead>
            <tbody>
              {coverages.map((coverage, index) => {
                const displayPrice = displayCoveragePrice(coverage);
                return (
                  <tr key={index}>
                    <td>
                      {coverage.name}
                      {coverage.includedNotRequested && (
                        <span className="badge bg-info ms-2">Incluso</span>
                      )}
                    </td>
                    <td>{coverage.maximal || 'N/A'}</td>
                    <td>{coverage.uncovered || 'N/A'}</td>
                    <td>
                      {displayPrice !== null ? `€ ${displayPrice}` : 'Incluso'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {rightOfOffsets && rightOfOffsets.length > 0 && (
            <div className="mt-4">
              <h3>Diritto di Rivalsa</h3>
              <ul className="list-unstyled">
                {rightOfOffsets.map((offset, index) => (
                  <li key={index} className="mb-2">
                    <small>
                      •
                      {' '}
                      {offset}
                    </small>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </ModalContent>
      </ModalBody>
    </PrimaInfoModalStyles>
  );
}

export default FacileCompaniesInfoModal;
